export const captureScrollPosition = (setScrollPosition, take, containerRef = null) => {
  if (!setScrollPosition) return;

  const rdgElement = containerRef ? containerRef.querySelector('.rdg') : document.querySelector('.rdg');

  if (rdgElement) {
    const { scrollTop, scrollHeight } = rdgElement;
    const positionToSave = scrollHeight
      ? {
          top: scrollTop,
          height: scrollHeight,
          take,
        }
      : undefined;
    setScrollPosition(positionToSave);
  }
};

export const navigateTo =
  (toUrl, toNavigate) =>
  ({ row }, event) => {
    const url = toUrl(row);
    navigateToRoute(url, toNavigate, event);
  };

export const navigateToRoute = (route, navigate, event) => {
  if (event.ctrlKey || event.metaKey) {
    window.open(route, '_blank');
  } else {
    navigate(route);
  }
};
